export const clientUrl = (clientId: string) => `clients/${clientId}/`;
export const clientWorkspacesUrl = (clientId: string) => `clients/${clientId}/workspaces/`;
